import { CarCarePageContent } from '@cinch-nx/data-storyblok'
import {
  AdminFeeDrawerProvider,
  StoryblokRenderer,
} from '@in-life-and-loyalty/vaps-ui'

import styles from './vaps-feature-car-care.module.css'

export interface VapsFeatureCarCareProps {
  children?: React.ReactNode
  content: CarCarePageContent
}

const VapsFeatureCarCare: React.FC<VapsFeatureCarCareProps> = ({ content }) => {
  if (!content) return null

  const wrappedComponents = content.body
    .map((el) => el.component)
    .filter(
      (el) =>
        el !== 'FeatureImageCardSection' &&
        el !== 'PeaceOfMind' &&
        el !== 'FeatureIconCardSection' &&
        el !== 'FeaturedEVsCarousel' &&
        el !== 'FinanceExample' &&
        el !== 'HowToGetCinchCharge',
    )

  const limitedItems: { [key: string]: number } = {}

  return (
    <article className={styles.mainSection}>
      <AdminFeeDrawerProvider>
        <StoryblokRenderer
          block={content.body}
          componentsWithWrapper={wrappedComponents}
          limitedItems={limitedItems}
        />
      </AdminFeeDrawerProvider>
    </article>
  )
}

export default VapsFeatureCarCare
